
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as appeOi5ToXlJIf1u_453ArgJfGx3F__Ht5Za7GwpKUexS6PAMeta } from "/opt/buildhome/repo/pages/(tools)/app.vue?macro=true";
import { default as indexV1Vws_UfiOV_7sHFbNbhAoB31BXf8h7WyoPlqeXIC64Meta } from "/opt/buildhome/repo/pages/anode/index.vue?macro=true";
import { default as indexz5O7pULYyPFB_A5pVmLOa6I39f86ASog6OHowpL7LTsMeta } from "/opt/buildhome/repo/pages/tools/index.vue?macro=true";
import { default as chartr3rn9Yk43VA8DzQ_z_T3HnuWuphPADYLyfp5oSyh05MMeta } from "/opt/buildhome/repo/pages/anode/prices/chart.vue?macro=true";
import { default as index26PnRex5Ak_45suLiH_k1HIoTKaRdogouS8VDlq8H6_twMeta } from "/opt/buildhome/repo/pages/anode/prices/index.vue?macro=true";
import { default as _91slug_93mKuO3HkhKWZn6x6Q8Gu6BUJs2NtedYnBD1gszUDIXYwMeta } from "/opt/buildhome/repo/pages/anode/prices/[slug].vue?macro=true";
import { default as pricesDSzs09F6ZLCQG29ymFDVPdlUYwfZF2Nb_45vKSwmRRZIgMeta } from "/opt/buildhome/repo/pages/anode/prices.vue?macro=true";
import { default as indexrKE5y1yBe1MpZTdEG_BdH_45IQpYwRVi8dC_45Ng_vJIENgMeta } from "/opt/buildhome/repo/pages/cobalt/index.vue?macro=true";
import { default as indexgV5H6VL612U6jL27JLgYyHNXmWydn7yq_TtYYRMF9bEMeta } from "/opt/buildhome/repo/pages/copper/index.vue?macro=true";
import { default as indexEi_45Uknbeg1CgFFca_45L5Ydki7XdS_u5UGtocjRA2uofIMeta } from "/opt/buildhome/repo/pages/nickel/index.vue?macro=true";
import { default as set_45passwordRVNlywD2VBOO_UxDrrgnf3Wgy4cZX6iXOZt5eJxN68sMeta } from "/opt/buildhome/repo/pages/set-password.vue?macro=true";
import { default as indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta } from "/opt/buildhome/repo/pages/account/index.vue?macro=true";
import { default as indexD2PZM2i5TGsluOtSKKcrPDVQJiZyp5yh9fbCRp_pA1AMeta } from "/opt/buildhome/repo/pages/cathode/index.vue?macro=true";
import { default as _91slug_93RvZMtPicDU0KWxDbagCqrRfxiNVvErblUw6QGTfQQkQMeta } from "/opt/buildhome/repo/pages/cobalt/[slug].vue?macro=true";
import { default as chartSoJMXbTvAjQCxJpXZgcYUAFZOzPeLumyP7Fde72GTMUMeta } from "/opt/buildhome/repo/pages/cobalt/prices/chart.vue?macro=true";
import { default as index1zfBnW0cRNv2eN29gwDOZs687CfLKFF3hUqzmCTHh98Meta } from "/opt/buildhome/repo/pages/cobalt/prices/index.vue?macro=true";
import { default as _91slug_93SJ5YyTlImcrhEYlKVSHCPye9ceo9bFaiVea9rSDaXhUMeta } from "/opt/buildhome/repo/pages/cobalt/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tooltced3pSYcJYm7TG_45053B0Rd3de1hsJbyT4bXCsigDaQMeta } from "/opt/buildhome/repo/pages/cobalt/prices/price-customisation-tool.vue?macro=true";
import { default as prices2RRxBXMGU9iWoiPD1IuYW2q9wdb2oe_GC4W6ZkGqDaUMeta } from "/opt/buildhome/repo/pages/cobalt/prices.vue?macro=true";
import { default as portalQkWIVq9Q4LTJk7nfExKm1JsGTo6pTCcDLoEZyunm3mEMeta } from "/opt/buildhome/repo/pages/copper/portal.vue?macro=true";
import { default as indexa8TZF5gFe8ppoZ05hiQiyaVGnNlztxvIaHmUgRiahtIMeta } from "/opt/buildhome/repo/pages/lithium/index.vue?macro=true";
import { default as _91slug_93ioCyLgO797rT4VKTQgM_YXDlBaSdSP7fSBqEOIPXLxIMeta } from "/opt/buildhome/repo/pages/nickel/[slug].vue?macro=true";
import { default as chart2HN2eqxHhuHGKdqUtY7zzNFP3lIT_9JAvisFTbkvnp0Meta } from "/opt/buildhome/repo/pages/nickel/prices/chart.vue?macro=true";
import { default as indexyl_45OzeNbqkwSta3hmXexzhQfmWKBjAQ_ymbIP1CuxzwMeta } from "/opt/buildhome/repo/pages/nickel/prices/index.vue?macro=true";
import { default as _91slug_93fk0slPu7RgEO8MO1aawZkiUeCtGOU8li47DkB8qUKgUMeta } from "/opt/buildhome/repo/pages/nickel/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tool2CPFVSdlSq5gxrCi41fTk8IZrLTX5xVayu8KvFumXt0Meta } from "/opt/buildhome/repo/pages/nickel/prices/price-customisation-tool.vue?macro=true";
import { default as pricesGLmo5Hyj3LNYlaN4s8_45JlstKyn3k29jrlBcYww8ntVcMeta } from "/opt/buildhome/repo/pages/nickel/prices.vue?macro=true";
import { default as chartg8b0cCAjfokZMR0k7H5g41bJ3mPHMfG3xqHj1I312BsMeta } from "/opt/buildhome/repo/pages/cathode/prices/chart.vue?macro=true";
import { default as indexnvKBJb1g0UuHHc1HMLtXSpMGhp2uHP85xJo5KtEAAVYMeta } from "/opt/buildhome/repo/pages/cathode/prices/index.vue?macro=true";
import { default as _91slug_93gFnDl6WQqejdL_IDw3NOYyQGINkXV2IYYUzNpo4uJE4Meta } from "/opt/buildhome/repo/pages/cathode/prices/[slug].vue?macro=true";
import { default as pricesfuwmmz7gcD24VAxvHEUL_45wZuOtwCkWu3ZygmjyvQGHwMeta } from "/opt/buildhome/repo/pages/cathode/prices.vue?macro=true";
import { default as _91slug_93QiR_45IFfz5gnb_PURgiRlEBQJJbD9_45p7E65H1M_45cokikMeta } from "/opt/buildhome/repo/pages/lithium/[slug].vue?macro=true";
import { default as charteL_ZgnPhxhgSBK4GsjTlFu_ehPBPpDJwg1K8_454R41sEMeta } from "/opt/buildhome/repo/pages/lithium/prices/chart.vue?macro=true";
import { default as index5RgLDA_w9cQRH1inImhoGpSVl2CsHinA3oF4agwFdMsMeta } from "/opt/buildhome/repo/pages/lithium/prices/index.vue?macro=true";
import { default as _91slug_9376Ef1pqhSPK3MZz2fN_45203gkNSSiose3PP63yAmbnoEMeta } from "/opt/buildhome/repo/pages/lithium/prices/[slug].vue?macro=true";
import { default as price_45customisation_45tooliq2dWHKcC7_XbP6xYy00RJIlmy31IOKaZd7PpdUisUEMeta } from "/opt/buildhome/repo/pages/lithium/prices/price-customisation-tool.vue?macro=true";
import { default as pricesr04WsZVosMYNPTGibZ9vrj0RPEfb74rVl8gFiKVWz9MMeta } from "/opt/buildhome/repo/pages/lithium/prices.vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as docsVT5BrI3IT_Tlfu9ApK34LNO5H75or93GRyO6kNw_GVYMeta } from "/opt/buildhome/repo/pages/tools/api/docs.vue?macro=true";
import { default as index7ldmIiBtJcKUbnfUx1KhOMc7CkkdFfkXrATN7i4bpkEMeta } from "/opt/buildhome/repo/pages/fluorspar/index.vue?macro=true";
import { default as indexfTjnSj5ZaZDm6sPT15BVMjUZ_jS6KmFryaTAN9d_45F4oMeta } from "/opt/buildhome/repo/pages/manganese/index.vue?macro=true";
import { default as indexX_45km_45nzcK8KTn2OSWLYqrEQrtgWpHsGfisnHF3fteV0Meta } from "/opt/buildhome/repo/pages/phosphate/index.vue?macro=true";
import { default as indexiHP_459aTnVcuNachfyBCN79XBQffLB7okl91Zmpui_45EkMeta } from "/opt/buildhome/repo/pages/recycling/index.vue?macro=true";
import { default as indexWRMlA4Ul3aF35L_45YOzeuGQIyEoULuQDdW8oeZptPrzMMeta } from "/opt/buildhome/repo/pages/tools/api/index.vue?macro=true";
import { default as _91slug_93vMVVn_2AU_LYP65s8waJQX5QVA8LPJAkVtjeJEIdXYMMeta } from "/opt/buildhome/repo/pages/recycling/[slug].vue?macro=true";
import { default as portalkwOl_lOUEv830UjhBpD7MvDLyfTP_l_Mrpx4ua521xYMeta } from "/opt/buildhome/repo/pages/recycling/portal.vue?macro=true";
import { default as indexAXftbV7OCVl2z5M2zjEzZx8dInE_45rT3_BIygGoNXNEUMeta } from "/opt/buildhome/repo/pages/rare-earths/index.vue?macro=true";
import { default as api_45accessPwZoObqN_o4XW0cPBPJfLl3QkAXdTVdAB4daz7PSOfUMeta } from "/opt/buildhome/repo/pages/account/api-access.vue?macro=true";
import { default as forecasts3IvqGGprpUYGk5jhOVbHxacCEOarLvy77lvyeYrpZO4Meta } from "/opt/buildhome/repo/pages/anode/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsPWvhULnhXknsD4_45gy15GT4vXVs2V6i6NiotM3It0JGUMeta } from "/opt/buildhome/repo/pages/anode/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsBY_xoXIpCtAQVdXM56XZdxB8pUJYgrDgTKJiYX6GZ6EMeta } from "/opt/buildhome/repo/pages/anode/data-reports.vue?macro=true";
import { default as _91slug_93nLwwDfZ_FuTf7ShngM6xEfFsHlixpW07o_k_45qAarL2IMeta } from "/opt/buildhome/repo/pages/rare-earths/[slug].vue?macro=true";
import { default as charttexBeRB82x0IvBMp1IzjNFVcyXJWtjwtJohWEHNyyVIMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/chart.vue?macro=true";
import { default as indexT4WR7U87NgilL3KdNawsWbjnA4yosLts5oSjEK2ON3IMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/index.vue?macro=true";
import { default as _91slug_93ZXw6TB6Fu9btkVLSm4zMahCcv_3wP2SDvoYoSetLlqUMeta } from "/opt/buildhome/repo/pages/rare-earths/prices/[slug].vue?macro=true";
import { default as pricesVhUiI68Gm9juvXqkg8W919ZjqghBWqxKglQ8B2FAU6oMeta } from "/opt/buildhome/repo/pages/rare-earths/prices.vue?macro=true";
import { default as forecastswWTMCeEeZMqD7_45ROr4fhdkb2hpM8LYCpqhPhrQ6efAwMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsMafhNoNLzAIaTTdXEpBpSpk38u_45NP39Z9R8TMUL_45W6sMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportss4K40O4facPwT8J6I6KcKLXbTSpCKg9KqfxrI_45RLvAYMeta } from "/opt/buildhome/repo/pages/cobalt/data-reports.vue?macro=true";
import { default as forecastsY2ZE2pWQVzJGhKhpCvNTuUnAxynX9paY6STXUCZKXH8Meta } from "/opt/buildhome/repo/pages/copper/data-reports/forecasts.vue?macro=true";
import { default as copper_45briefingo_BfcMqB92NCOddwCLy0UzA4WXHyApkNb0DUhdZbTSEMeta } from "/opt/buildhome/repo/pages/copper/data-reports/copper-briefing.vue?macro=true";
import { default as data_45reportsZtrftu_45s1VwG6KE3T_45EdhmaZSLngbHCK_45NRvPSdDxowMeta } from "/opt/buildhome/repo/pages/copper/data-reports.vue?macro=true";
import { default as forecastsZHqrEclrJvzMk9Pp8EB4mZIAUWmJFgkY_4553JzhajdHoMeta } from "/opt/buildhome/repo/pages/nickel/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsl2WZJLg1kRluP_LgLDdeppiF7cuYQGYEEAeAU76UKvYMeta } from "/opt/buildhome/repo/pages/nickel/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsdkxV049C969_ZLDTteN4O4gjbrDIelK2_454p5rjogmucMeta } from "/opt/buildhome/repo/pages/nickel/data-reports.vue?macro=true";
import { default as indexwZyhkeIhahNSKbj9Mv2sC2smueJzC_OcAcagsfvyxq0Meta } from "/opt/buildhome/repo/pages/silicon-anode/index.vue?macro=true";
import { default as excel_45add_45inkLpB7V30LFWT33tZ2u_45merba1hB0B1OIQz5yJ_aHQf0Meta } from "/opt/buildhome/repo/pages/(tools)/excel-add-in.vue?macro=true";
import { default as forecastsy7ILvQmepxTh90vSjydKOfDz12wakD5W24y54oSkI7oMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentszPSDrMkqlF6_45PDwG6_CA1A0GCeTJiEB1fzPyAu_45M4BUMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/price-assessments.vue?macro=true";
import { default as market_45assessmentsNBA70qiYi6i8b8xgJq7ija5smxnaEpflZAwTGrIjPRUMeta } from "/opt/buildhome/repo/pages/cathode/data-reports/market-assessments.vue?macro=true";
import { default as data_45reports06kz19v3kt4p0B2H0NMCfEWqOXyyUjRpK3Le1hz7WcgMeta } from "/opt/buildhome/repo/pages/cathode/data-reports.vue?macro=true";
import { default as forecasts81PBPUNkXuwxgNjH6STLKAH4VxrROISq69bG5a994VgMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/forecasts.vue?macro=true";
import { default as sustainability_45Cvpto0q1X29YdY8LdDbL1f4tL5C3xTcpmKUaQA83JgMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsoQ_tH3hE3ijN35zbk_45BsN1EBajFvDlcZE2adkwPYF4IMeta } from "/opt/buildhome/repo/pages/lithium/data-reports/price-assessments.vue?macro=true";
import { default as data_45reports1c56zMU_Ga1PJyuYOu2dBK12xqN2JkpGcdgi_tQFadIMeta } from "/opt/buildhome/repo/pages/lithium/data-reports.vue?macro=true";
import { default as indexUVUbiAmmZwjFLCnBTStGBUj8_45nU2H71POr7C2uvRudkMeta } from "/opt/buildhome/repo/pages/new-technology/index.vue?macro=true";
import { default as subscriptionsef8m95Q1E_45J79LcAd_45RAY3qfixo1CSpfsxjqNkfKKfoMeta } from "/opt/buildhome/repo/pages/account/subscriptions.vue?macro=true";
import { default as videosy5MiVRdy2L0bmp2J41MlNQYSqsC55587_MPpizBiApIMeta } from "/opt/buildhome/repo/pages/anode/market-insights/videos.vue?macro=true";
import { default as analysis5FFClH0s3_Z9DfXtMj8JRr31rrY7vEU9mjOB__451cFxYMeta } from "/opt/buildhome/repo/pages/anode/market-insights/analysis.vue?macro=true";
import { default as critical_45insights_45JCgfsA4mqrMoEqIBpCOy8kJMR4hjCEFtfuOpNklEU4Meta } from "/opt/buildhome/repo/pages/anode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsGuVDAInSEoIbTR5CcZq7vjv9mzDuccwlXoGaq_Zui1sMeta } from "/opt/buildhome/repo/pages/anode/market-insights.vue?macro=true";
import { default as lcayx_45ZHm5ATA3otzyD52GFUv_45YZrmQ_45PQTHcfQnZ9ibzYMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/lca.vue?macro=true";
import { default as overviewOiSHrrphhatmJCe2BWFVh1eCsjJUdfuG1J4L9LPEEEcMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexPxo5pxfv8uRaz2YnuUWwtFYrOWSXhrQLbd4KQNp__45hMMeta } from "/opt/buildhome/repo/pages/cobalt/sustainability/sustainability-index.vue?macro=true";
import { default as sustainabilityB3Bm5CXSr7bLQzy_mp_45BITKB7N_455RU8OE43qP9HaFD4Meta } from "/opt/buildhome/repo/pages/cobalt/sustainability.vue?macro=true";
import { default as portalgX1PHDCPzycm7l7BYZTgbFP18c9puZpB1OjTvTmPickMeta } from "/opt/buildhome/repo/pages/new-technology/portal.vue?macro=true";
import { default as lcaZaBFLidf51Nik5KU1lm_453FA7IkhtqtdO4W0IHi68eD0Meta } from "/opt/buildhome/repo/pages/nickel/sustainability/lca.vue?macro=true";
import { default as overviewpDONLyavM7wWQwmoi5fqHk34cz83iURPUSqdsrJbz2cMeta } from "/opt/buildhome/repo/pages/nickel/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexWE8xj0imX3ZZJIUpQw9UjmmjU6SCaaj1ouM_wrizCHUMeta } from "/opt/buildhome/repo/pages/nickel/sustainability/sustainability-index.vue?macro=true";
import { default as sustainability2jCBcwzGLi7J36_rCystW_45uJn8AuXafDEREovIV5mKgMeta } from "/opt/buildhome/repo/pages/nickel/sustainability.vue?macro=true";
import { default as videosfjbFi30_45rY_jXx60zayApKwRibQjf53Rw1saKzWSQSEMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/videos.vue?macro=true";
import { default as analysisu1fmvvcBMbhS6vTsxbg8lghUNehgRZvqWQsKeeko6ggMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/analysis.vue?macro=true";
import { default as critical_45insightscjYrhSCoDX07vbvyFXAWp0FdMpxSjiQbUCdqKHemmtIMeta } from "/opt/buildhome/repo/pages/cobalt/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsbJEI_45ucptiXRxpSd_Cy_sB5T0VQa14vCGmL6kcyuGm4Meta } from "/opt/buildhome/repo/pages/cobalt/market-insights.vue?macro=true";
import { default as videosnrJQHrkuQe7hWYr9yVKTOR0RUrMZ9ivKalf9UrgTUQoMeta } from "/opt/buildhome/repo/pages/copper/market-insights/videos.vue?macro=true";
import { default as analysis5_SOI7W6_6pDje3YGNhXZegE7x8AmH3rqGgNta40wlYMeta } from "/opt/buildhome/repo/pages/copper/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsDVMy160VIkGeQGSlyRG1_vzpwiF3Kw1E2fFXW55ILxkMeta } from "/opt/buildhome/repo/pages/copper/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsw1SXVjd1K9YU9hqNXrBx8uQ4tHehmEHMMN8Ki8f8FugMeta } from "/opt/buildhome/repo/pages/copper/market-insights.vue?macro=true";
import { default as forecastsa9WT5jxj6deKOkW6Ezb_Fmy3CLfTRgcddOaSyw1KGB8Meta } from "/opt/buildhome/repo/pages/fluorspar/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsgbaZOc4gjryF3Jb_45qC35u4ccSIdKxv_pOB_45X1lc3ujUMeta } from "/opt/buildhome/repo/pages/fluorspar/data-reports.vue?macro=true";
import { default as lcaf7X6UACeaKEWCjUXVHYczDwgw_451G1iES2RS_L8AlTVsMeta } from "/opt/buildhome/repo/pages/lithium/sustainability/lca.vue?macro=true";
import { default as overview8T1RWuRf6net1QW8iUWX0WnZ7iioLX_JNeLJJBx3rw0Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexheyROYfwaI3xtQFWRDpPpheqpIkTAik_njvWEAqucM4Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserxkEwC5fkTnREyQ_QvfOtD3UPc04aVK30Eoit5eL_45268Meta } from "/opt/buildhome/repo/pages/lithium/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityRRq6jml3Evu7C9B7lW5dnBywTM1smWIxhO_67TqtIbEMeta } from "/opt/buildhome/repo/pages/lithium/sustainability.vue?macro=true";
import { default as forecastsqhz6DZ_5ahlGd42Xj5a0DyDJJi9gd6wRdXGGydNHTDwMeta } from "/opt/buildhome/repo/pages/manganese/data-reports/forecasts.vue?macro=true";
import { default as data_45reportstLPdngfcbBB791bXHQbpUAM6P1VbYJ_q4yzgxDCepnUMeta } from "/opt/buildhome/repo/pages/manganese/data-reports.vue?macro=true";
import { default as indexKM6uOX9_45GMWZMOKmdmrvqcgwfLORqhSrZwJ5gMM9qpkMeta } from "/opt/buildhome/repo/pages/natural-graphite/index.vue?macro=true";
import { default as videosct7YXBA8E9UNyUyx0giUwiUwnnmNEhFBFmxvm88K1r0Meta } from "/opt/buildhome/repo/pages/nickel/market-insights/videos.vue?macro=true";
import { default as analysisV8x2wsWnfOSi9VUF_UUkqogCWlPrUwagyiDeFJ_45Xe0AMeta } from "/opt/buildhome/repo/pages/nickel/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsyqJb75QXjoaS718x_45Tp_lDTrNhai_45P2bXbeAO_45MoIEIMeta } from "/opt/buildhome/repo/pages/nickel/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsW8daf7d1dbOMjPfxDsbYCDGpworFjvtBVU_gAhTKDbAMeta } from "/opt/buildhome/repo/pages/nickel/market-insights.vue?macro=true";
import { default as forecastsWJXcSRnSJh6FSPydQa6fFBKhs5h_45s72Z4sVqBrnVoPsMeta } from "/opt/buildhome/repo/pages/phosphate/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsI54m0M32_45SK3h16wa7wjcPyKmaR7dq5lORcWPtgTFqgMeta } from "/opt/buildhome/repo/pages/phosphate/data-reports.vue?macro=true";
import { default as forecastseYADkzkcfdqJo1n_45Crnq_45UbTp9YNpvwa6_X_45YGBsmlwMeta } from "/opt/buildhome/repo/pages/recycling/data-reports/forecasts.vue?macro=true";
import { default as price_45assessments0dk6nCKYyPX1PHUqi0iWeP9voI8rYzlxkIS7NhO4xUEMeta } from "/opt/buildhome/repo/pages/recycling/data-reports/price-assessments.vue?macro=true";
import { default as data_45reports8U0FRTokFK4DfOLIG_452PiazaTs0mWOoc9PRwB5zJ55UMeta } from "/opt/buildhome/repo/pages/recycling/data-reports.vue?macro=true";
import { default as index59bt1rmJZPF5B1AXzbCYXGUlccWvaORTCmQyf8uvAR4Meta } from "/opt/buildhome/repo/pages/anode/capacity-database/index.vue?macro=true";
import { default as sodium_45ion_45anode6HYcK_455cnUsCcufm5p9YCRAO6kUog4fizC__4GxCdRcMeta } from "/opt/buildhome/repo/pages/anode/capacity-database/sodium-ion-anode.vue?macro=true";
import { default as capacity_45databasee7l3ptyb4PBHK49UF0_45vwBoZZBEicrXXeJVw5tkExhkMeta } from "/opt/buildhome/repo/pages/anode/capacity-database.vue?macro=true";
import { default as videosVoLh_OnGnlWqnnBqN8JN9lfZZ_45Ea5I1XftJUqPWNuM0Meta } from "/opt/buildhome/repo/pages/cathode/market-insights/videos.vue?macro=true";
import { default as analysis79bxjcLYh5cEitnEPVYtiQ04193bkSlt9Gi6A6gsnqoMeta } from "/opt/buildhome/repo/pages/cathode/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsjeY_p42kgvoKDh1Tk5P9ii1RJ1ImiHUF3gX29kwDkg4Meta } from "/opt/buildhome/repo/pages/cathode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsU5gHCz9ft_nIlfyFVrFhUfmyeBS8gSirt5ow82_6xJ4Meta } from "/opt/buildhome/repo/pages/cathode/market-insights.vue?macro=true";
import { default as videosF8JU2lzZwewvlRH4KBsuhk7dlXWcNbgArzcdVrpWwjIMeta } from "/opt/buildhome/repo/pages/lithium/market-insights/videos.vue?macro=true";
import { default as analysis1a_FKHv0M2pcWOhwC5lzbYZBY0eHP2qRpN814d84iBQMeta } from "/opt/buildhome/repo/pages/lithium/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsIW0hwN71Mi1H06SnPg8GOL6Cld7e_eLTRieBqe99Ao8Meta } from "/opt/buildhome/repo/pages/lithium/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsM5dXX__45RoyRTwmx_synaTlnFC9iJdRQ1OcjPuFTys8YMeta } from "/opt/buildhome/repo/pages/lithium/market-insights.vue?macro=true";
import { default as _91slug_93hFDYNoOn5JPJkLetDsmmV6hESng88HNmx58klRfVDc4Meta } from "/opt/buildhome/repo/pages/natural-graphite/[slug].vue?macro=true";
import { default as charttcUJKh0e_45IU6ZIrIhnGeIADKU8HYidR06on1tbbpLVAMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/chart.vue?macro=true";
import { default as indexyiHprQZOFqpNOOiyJeC3w2NXSv745ik1WVFMuHBu0CkMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/index.vue?macro=true";
import { default as _91slug_93I_U2Nt3gflNitMu9eI9Kql7pF5bKHQX42TevxWRWMUYMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/[slug].vue?macro=true";
import { default as price_45customisation_45toolKj1TXNon5EeyEnhM_45bQRH5TtD_2W9n6cwbF1EZQkOPEMeta } from "/opt/buildhome/repo/pages/natural-graphite/prices/price-customisation-tool.vue?macro=true";
import { default as pricesPqFK_45fp_5oTSpxAe8qj6c98yKd4HTrJ524ET1K5N6P4Meta } from "/opt/buildhome/repo/pages/natural-graphite/prices.vue?macro=true";
import { default as forecasts2F3r_45x7PZfr4UlpYbQvHJ33qnzThmxsW7CPDlBl5TyUMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityDxjSzjD10HbEV9EidxDExoIe4wZrbT1WlLSNMNxpECoMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsC3_45XGH3WzlJR_45ilbNxGyC5Qd0t3fd2scvM0JQF9XOv0Meta } from "/opt/buildhome/repo/pages/rare-earths/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsNEZHWzcOS_gek61NkZAyrUjqaEW27iFykqQc6RnDILMMeta } from "/opt/buildhome/repo/pages/rare-earths/data-reports.vue?macro=true";
import { default as indexSrflw_45RKtNDaCfGXveUmgg8K5vQq_9oSJ4p2rbcBwfUMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/index.vue?macro=true";
import { default as indexg_VlOVtVubGPiI0xh_hA_45TvAQYh9BKrLhlPit18edXEMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/index.vue?macro=true";
import { default as indexlZMtPlsjQO4dc9q6Ym_CuZsWREDDaO_45bKCvfOUNNzxwMeta } from "/opt/buildhome/repo/pages/cathode/capacity-database/index.vue?macro=true";
import { default as precursorQcp_x83GfokouyURfYws_fnQLNKRZK_go9DovuMLkd4Meta } from "/opt/buildhome/repo/pages/cathode/capacity-database/precursor.vue?macro=true";
import { default as sodium_45ion_45cathode8f_gXVdMQWt_45_45ekL_vWQO_nZzs5g_45jFBWgrEnjNLfr0Meta } from "/opt/buildhome/repo/pages/cathode/capacity-database/sodium-ion-cathode.vue?macro=true";
import { default as capacity_45databaseFSnHeDo1aAHeEh_459j1JnM7LaMVkISGj8wffjzQlAVdgMeta } from "/opt/buildhome/repo/pages/cathode/capacity-database.vue?macro=true";
import { default as videoskqyxF7jy9PnZ1jDEqmteQk3hIMh4jMejeUz6SqvZjo0Meta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/videos.vue?macro=true";
import { default as analysisbUlncyfMIlJpLAVvUUVvqehd005v0PgAq38_45HxwNeSIMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsy_oQxWsmyAiuOBAoyw4g1KEpIs_PJJ7qjOc5jVMnGjYMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsb9dsM_TdtGGMsKBbxHj74YftTzrQmenZmUZ6InEHCNQMeta } from "/opt/buildhome/repo/pages/fluorspar/market-insights.vue?macro=true";
import { default as videos1PrpHdQzU6pnJ9mmu7kUDOl840655uEAh_45_PY_45v8BUUMeta } from "/opt/buildhome/repo/pages/manganese/market-insights/videos.vue?macro=true";
import { default as analysis1KicjvkWw8JC3GGsw_Dhqj9UPe29In9FmNQ0qweCFe0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights/analysis.vue?macro=true";
import { default as critical_45insightss3V52jfdh0dDsdyinmOo5sAk_45gJHHs2r7xSRriYMyg0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights_gh6CFo9yga2a9KKiHjmZyGUcLfXJUxlG_LMAVFC7w0Meta } from "/opt/buildhome/repo/pages/manganese/market-insights.vue?macro=true";
import { default as videos1qVEKZGjHk_AJmawVd0oeFfZ1KFRSzeCSyi3Rjm_45xXsMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/videos.vue?macro=true";
import { default as analysisnog_45e13M66QjzZZCWS8uYSXbBabyg5KY7GIX1WEzGDEMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/analysis.vue?macro=true";
import { default as critical_45insightszCDr_45UCacJc6Mzb_45Rb1x5nqYvzy0r9YoQPWUe3051isMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsw3spT2DD0X8iDJ9XMUlCW9a7vPewU4fBCPr1XJLevlwMeta } from "/opt/buildhome/repo/pages/phosphate/market-insights.vue?macro=true";
import { default as videosUD9lI68mx_45lPTnTtGeXk_45WBE2jMChlHLIc7ZcTuFTYUMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/videos.vue?macro=true";
import { default as analysisske8hu_45i9MzfTcJIBOq_45Hi3ZLr4ClN0ASh7DC_45EBZTIMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/analysis.vue?macro=true";
import { default as critical_45insights9EQQ4qc2i3C992dsbiDbTcke7KTB3rQKOlfqQblW17wMeta } from "/opt/buildhome/repo/pages/recycling/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights8PI2RbciLA1HlUdv79ciCwpF_pe1VGjfc04t3IVsguMMeta } from "/opt/buildhome/repo/pages/recycling/market-insights.vue?macro=true";
import { default as _91slug_93XVV7pHxh0P2Ub_UWh9eTsKfCB_NIBXrjtwKuupSfVMwMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/[slug].vue?macro=true";
import { default as chartphzVXtDbi_5ZcR_45CGbmUkFqLJ2D2zODv1xZV3StLKj8Meta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/chart.vue?macro=true";
import { default as index_45JXSe5i9wiyNW_45v7xMDNN2FRY0nOzlAYvEq8gsneMSMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/index.vue?macro=true";
import { default as _91slug_93fTlU5OeCdw6Aj4Bph5fuN2_45UwfqP1CAmrbvTJpuQqEoMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/[slug].vue?macro=true";
import { default as price_45customisation_45toolbidZOjWILLSf9O9xAW9fB0sEBH2IFSR_9N8INSUz1ckMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices/price-customisation-tool.vue?macro=true";
import { default as priceslFCozIzKvzh7HqTQE0hsdOYkBWnrHAvbTg7IecnOoEcMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/prices.vue?macro=true";
import { default as portalLnGbyVnCR5f2OGb2fH7n1GNq2UTqDFNdR0PG3tf78BoMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/portal.vue?macro=true";
import { default as lcaxoFOsuSwKQb8tvTv3nSTqveEln_o_45XRGORB53eTbWPAMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/lca.vue?macro=true";
import { default as overviewseruQu25iPLw__ti_WGPGSEtaDBI3DtESohmBWG3OuwMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/overview.vue?macro=true";
import { default as sustainability_45indextXXGfoXEGn3iYjzp2POvI_3yJX0KMxp2lZtYB_45e9_BUMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability/sustainability-index.vue?macro=true";
import { default as sustainability2HKR2AFr0MctOn9CV7vPIu64FRHKsDfB2M6CALsw2qgMeta } from "/opt/buildhome/repo/pages/rare-earths/sustainability.vue?macro=true";
import { default as forecastsM2Exh7WIHeUe14hSTbD7WxwYx3RBA7DCMq6RYdzdUkcMeta } from "/opt/buildhome/repo/pages/silicon-anode/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsoy_45mVMUK_459kR88u5jCE44pYOVS8dpolYgdM4bFXvTCQMeta } from "/opt/buildhome/repo/pages/silicon-anode/data-reports.vue?macro=true";
import { default as forecastsDaiL_2OV881qCf22HIymn_45wT9AmeHaWlXC4MmJv2d_cMeta } from "/opt/buildhome/repo/pages/new-technology/data-reports/forecasts.vue?macro=true";
import { default as data_45reportsejLkMefl5i_wtXI_45u3LMSPFUwA9WmL5mI8xMm9btwEkMeta } from "/opt/buildhome/repo/pages/new-technology/data-reports.vue?macro=true";
import { default as videos9C950AHA8vq8KkjSEgBZ63RLSMcSv0wjIpdfkKlxnecMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/videos.vue?macro=true";
import { default as analysisRkzKQgzK_iTGniALJOXkL2NH2juv_arQ80gUEjzj9tAMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsIeRbaUqxZBWpLP09IveEoA6OINVYFInWRb2wgJukTzsMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsspHqgPkgSAg4L7Msp0ehClMKAzoudmTrLqcyEn_45ttgcMeta } from "/opt/buildhome/repo/pages/rare-earths/market-insights.vue?macro=true";
import { default as chartaTXhIT6_hAQmVmAUEuTvACXgXm2hY3FyC5nVvvQSLcUMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/chart.vue?macro=true";
import { default as index6PNkphKUs0xAC5idz0vkTJDVQZp_pQ27na3iBzH244AMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/index.vue?macro=true";
import { default as _91slug_93PO3QpZcwMEyVk62yvFFzeWLC_YGd_F1w3sngwH1CM7sMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices/[slug].vue?macro=true";
import { default as black_45mass_45prices4pzz_REFyAbbL_3kOWyJaY6t6IEYzCJ2Wkk_45OcgH3BoMeta } from "/opt/buildhome/repo/pages/recycling/black-mass-prices.vue?macro=true";
import { default as forecasts_SPAejp_sbgY1blBL15_4533YM98RYIUUUk_45ZUAHicatgMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityuvcVYKUbN7UY4ehckJs4tMq_t_idpFnI7cHQ_4579X2_450Meta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentshBFZqzulBQxxANaNYDbac5SZtlaJEkZ4Gomh9q4Dh9oMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsct7S3OMqT8zEYlfsqMtNMCkdaWi9IGLKzpoBpo1HxvUMeta } from "/opt/buildhome/repo/pages/natural-graphite/data-reports.vue?macro=true";
import { default as chart_45builderlr6t8ngqoqfqxbU9_45N_JoNIGuRJEtxe2Rkb7ZGTJH70Meta } from "/opt/buildhome/repo/pages/price-dashboard/chart-builder.vue?macro=true";
import { default as videosTdoIRuhAzEEndBQvQWKD6V3KB0iuu_4y1dWO4HpZUFoMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/videos.vue?macro=true";
import { default as analysisZmBLceel3q13JNUtuvWS23Kukt9L54_45csgtyxWqNvcYMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsyMzDn1yaPcKFGI_WteHLz_45O9rhf25nMAl3d3DTxsbQ4Meta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsrcF_0Wg1WNxiJvWTztOLtva9g7fdswL86IwuUxpclkUMeta } from "/opt/buildhome/repo/pages/silicon-anode/market-insights.vue?macro=true";
import { default as videoscK9da_9Rv1JIraHrzZA8ghJvJGTMq31OCg_Dae7FUB4Meta } from "/opt/buildhome/repo/pages/new-technology/market-insights/videos.vue?macro=true";
import { default as analysis8_my2XChk3PRA2DFDPU25MVWnlyfHcfS26py0ZFGvNkMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsiViy2OdOhzByJJAKXJTFIkn4__SN_453OZZJR11vJRkXsMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsNIP2_WMMsEu6qVV09yRbomxPXR5CMjup8MqY0SRQyJkMeta } from "/opt/buildhome/repo/pages/new-technology/market-insights.vue?macro=true";
import { default as _91id_932ttV3F0SuVBw0tXLyLFOtjM6sg6OatpxohoiTnci_459oMeta } from "/opt/buildhome/repo/pages/price-dashboard/watchlist/[id].vue?macro=true";
import { default as lca50Mu2Us9_tmSXZljHPCgg_45BjA9WEbwvncEJCiGR4lVsMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/lca.vue?macro=true";
import { default as overviewcC3cqKqf8KKcWNYve6_45HkSlffqxhMm_45BczOEaJ_45IdBcMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexneUZ52JNw0BJFtrEL_45_09xeBBVporaptGY2Nw3sXtOUMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserCeC_R_604avO_ZNKVCEFYFAZEkJ95uF3TRloiMbGkEoMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityGGHxoVd9mBBqCtPJnKLN7N6vecP_SPO8Paoh97L9_ZUMeta } from "/opt/buildhome/repo/pages/natural-graphite/sustainability.vue?macro=true";
import { default as index1WsTlVhvhQXMTPMtibJk3sjemyv9V0NKZyWp60MzQjYMeta } from "/opt/buildhome/repo/pages/price-dashboard/watchlist/index.vue?macro=true";
import { default as forecastsQm8J_45GWfyJ7deQCfAUrCYzf5LMse25QvHneyLoDvwoMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/forecasts.vue?macro=true";
import { default as sustainabilityo1ipOGWYHkIxbq13M1YqwqjAYRSWQ7GMGu9ONtxN71oMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/sustainability.vue?macro=true";
import { default as price_45assessmentsVOv21o3fPLQb4GrRovYMBKr49WQs6JJ5VxAv0uLnTCAMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports/price-assessments.vue?macro=true";
import { default as data_45reportsYcFdpkhIbSlj7hLqpSADre_45QBo101OsUQisv2cOnk5IMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/data-reports.vue?macro=true";
import { default as forecasts69Zg4JpnM7U13Ja3EF2xvczl8ybgDxzmqF_45xj2ZBT1sMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/forecasts.vue?macro=true";
import { default as price_45assessmentsc4DuL6Qtq9BG9DQCvAtedEoo_45IsZeClGR9o4XPV1acIMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/price-assessments.vue?macro=true";
import { default as market_45assessmentsTptWk9rthyQqHXf7fNV6u8m_45I14vkrvEM4syvhqVLJ8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports/market-assessments.vue?macro=true";
import { default as data_45reports_45c9ylmhlcPihaO_45UN6rUaOfrxyNqFsLkBVeAnKWJD_45wMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/data-reports.vue?macro=true";
import { default as videos8QQy85x165BbCeXcjr_4FYnS0DMZjbWeVzMSFuChhvYMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/videos.vue?macro=true";
import { default as analysisD_2hag6U4b16g_4J6zS2fOioEWxDIRmABco91ldFCA8Meta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/analysis.vue?macro=true";
import { default as critical_45insights3pn3HKWcEYwzKeGauhpfFZqls6Tz7Wh3p7l8ZImrhXQMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsHrfjydOf4OFO5Paxo7ZdBXmqTKdzdddYI3IxouRBmzEMeta } from "/opt/buildhome/repo/pages/natural-graphite/market-insights.vue?macro=true";
import { default as lcaWQ_XjzbRRtMQwsQF0LHMeae9bZ3v_45fALPuLApiQCwDMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/lca.vue?macro=true";
import { default as overview97z0CWhh8uCHPkjuvl2_ybGPIyikIOwXw6CIwzlrJSMMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/overview.vue?macro=true";
import { default as sustainability_45indexe7ePvFcIuRqxtG_TffLK5P3H8_456uFjk3iDHIvOFly6QMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/sustainability-index.vue?macro=true";
import { default as battery_45emissions_45analyserbRvYGu8mnd2FhG4G1HWKnyL5ZkFDEkjV3nNWob5y7k0Meta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityguROWt1ceEKfHogtidtK22y6_45eZY0WJ_IETmEKd7umQMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/sustainability.vue?macro=true";
import { default as battery_45emissions_45analyserJZm_45OEOnUwb3_c_1X098pltBhAPAGyyT1h7UY2dM2TUMeta } from "/opt/buildhome/repo/pages/(tools)/battery-emissions-analyser.vue?macro=true";
import { default as overviewPorE21G2DcJvXbC2zB9xGLjikG45aEENrm_5mGcJqQQMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability/overview.vue?macro=true";
import { default as battery_45emissions_45analyserCbZyhGlfVk43_45UYSJRmFk0IGrb2iEvlhlQLRmNEEuRMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability/battery-emissions-analyser.vue?macro=true";
import { default as sustainabilityXSUHVPWj6msca7IkXe0809IigjfGwkLPkl7EBE6mnY4Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/sustainability.vue?macro=true";
import { default as videosFgYARxTX82gCmew1FsOwNF_PD5tMFd_45W3SOESwCgKmQMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/videos.vue?macro=true";
import { default as analysisJyYEHqLSh7FoHIGE00oRhBazBnfdW2tZto1tIkA2OWkMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/analysis.vue?macro=true";
import { default as critical_45insightstENqEa19jEQuKHTejOqETWAHiowVRpPu71T6Np63y_45MMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights/critical-insights.vue?macro=true";
import { default as market_45insights6jpXxHyGG6Wo2TGR5uGwUrgWebwVVe9LahhJwKn2NPsMeta } from "/opt/buildhome/repo/pages/synthetic-graphite/market-insights.vue?macro=true";
import { default as videosNp3LGbSz_45Fi6zHbglRQS3bNCUb3YVdPFqGCRfR_45fWW8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/videos.vue?macro=true";
import { default as analysisvnlDS022c5PHjBlNjjxYMqlAJxXJOXbdrrzTaMduP_45IMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/analysis.vue?macro=true";
import { default as critical_45insightsW6vfrvQHX60i_45O_45_45HDRLK9BUT998DerUIDSqTAvCwBMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights/critical-insights.vue?macro=true";
import { default as market_45insightsABYc_45XgLcXtzZITJL4UiDb7H_45bwv81_45qChYCBr4ZH3sMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/market-insights.vue?macro=true";
import { default as indexBlR3koxPdeiuXWb4O0X_IasfaD6FoYz2u111LdRFRuwMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/index.vue?macro=true";
import { default as battery_45cellzh_lsHvarVb1FIm6dRcach7u1RCj9gm7i2E_45CUHdUw0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/battery-cell.vue?macro=true";
import { default as sodium_45ion_45capacitiesrTNtQAlnQH2cwCm2t2EI4gJx5DYeCatPtZORHc2ZXhkMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/sodium-ion-capacities.vue?macro=true";
import { default as capacity_45databaseco42LG5QtrGnwlJrYDpDh7uiRmc17mtK4jSLOnCwHKcMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/capacity-database.vue?macro=true";
import { default as indexLKNcEHi9krQyUUFbezdWO1G36WmicLs_450nwH6KyxKdgMeta } from "/opt/buildhome/repo/pages/[market]/market-insights/briefings/index.vue?macro=true";
import { default as chart9Vq24jqjf6ycod09reGJLcmT8DeOZXfOihrIjrdqDx8Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/chart.vue?macro=true";
import { default as indexXW_73qxVw_45AO29bMNzSXAJK3RU89H68LA6Ix9p64_q0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/index.vue?macro=true";
import { default as _91slug_93M9Fp0dxzKsebaAaHG0un8dU2nR0q35p8o0UmJs4ToLMMeta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/[slug].vue?macro=true";
import { default as lithium_45ion_45batteries_45pricesc1qoYTLD6ULkoQ9aBDx2jBIgxAocVkssX6d_FvP4VS0Meta } from "/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices.vue?macro=true";
import { default as _91slug_93Y5plBC6ZUhGMGhBd8Lp7bSnvWV0jWvdbNzLNGMmkPq8Meta } from "/opt/buildhome/repo/pages/[market]/market-insights/briefings/[category]/[slug].vue?macro=true";
import { default as _91id_93aHRD_45C62bpxQlXiJyTO0jL2I7qPg_pOCc0_xNnliX94Meta } from "~/custom-pages/[market]/data-reports/[subCategory]/video/[id].vue?macro=true";
import { default as _91id_93fW65Rf0tLwtKeru2QgILXBNROxdqKSkj74UAHmNka1IMeta } from "~/custom-pages/[market]/data-reports/[subCategory]/report/[id].vue?macro=true";
import { default as _91id_935fjG9iKCprPRoUGUgPHbl5pkqVS5lZAMFE6hwtlKstQMeta } from "~/custom-pages/[market]/data-reports/report/[id].vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: appeOi5ToXlJIf1u_453ArgJfGx3F__Ht5Za7GwpKUexS6PAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/(tools)/app.vue")
  },
  {
    name: "anode",
    path: "/anode",
    component: () => import("/opt/buildhome/repo/pages/anode/index.vue")
  },
  {
    name: "tools",
    path: "/tools",
    meta: indexz5O7pULYyPFB_A5pVmLOa6I39f86ASog6OHowpL7LTsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/tools/index.vue")
  },
  {
    name: pricesDSzs09F6ZLCQG29ymFDVPdlUYwfZF2Nb_45vKSwmRRZIgMeta?.name,
    path: "/anode/prices",
    component: () => import("/opt/buildhome/repo/pages/anode/prices.vue"),
    children: [
  {
    name: "anode-prices-chart",
    path: "chart",
    meta: chartr3rn9Yk43VA8DzQ_z_T3HnuWuphPADYLyfp5oSyh05MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/chart.vue")
  },
  {
    name: "anode-prices",
    path: "",
    meta: index26PnRex5Ak_45suLiH_k1HIoTKaRdogouS8VDlq8H6_twMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/index.vue")
  },
  {
    name: "anode-prices-slug",
    path: ":slug()",
    meta: _91slug_93mKuO3HkhKWZn6x6Q8Gu6BUJs2NtedYnBD1gszUDIXYwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/prices/[slug].vue")
  }
]
  },
  {
    name: "cobalt",
    path: "/cobalt",
    component: () => import("/opt/buildhome/repo/pages/cobalt/index.vue")
  },
  {
    name: "copper",
    path: "/copper",
    meta: { ...(indexgV5H6VL612U6jL27JLgYyHNXmWydn7yq_TtYYRMF9bEMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/copper/index.vue")
  },
  {
    name: "nickel",
    path: "/nickel",
    component: () => import("/opt/buildhome/repo/pages/nickel/index.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordRVNlywD2VBOO_UxDrrgnf3Wgy4cZX6iXOZt5eJxN68sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/set-password.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: { ...(indexsSHEynImpmVJQBsgEWtpFbTIimvAlNbjHy0W37sieOIMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "cathode",
    path: "/cathode",
    component: () => import("/opt/buildhome/repo/pages/cathode/index.vue")
  },
  {
    name: "cobalt-slug",
    path: "/cobalt/:slug()",
    meta: _91slug_93RvZMtPicDU0KWxDbagCqrRfxiNVvErblUw6QGTfQQkQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/[slug].vue")
  },
  {
    name: prices2RRxBXMGU9iWoiPD1IuYW2q9wdb2oe_GC4W6ZkGqDaUMeta?.name,
    path: "/cobalt/prices",
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices.vue"),
    children: [
  {
    name: "cobalt-prices-chart",
    path: "chart",
    meta: chartSoJMXbTvAjQCxJpXZgcYUAFZOzPeLumyP7Fde72GTMUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/chart.vue")
  },
  {
    name: "cobalt-prices",
    path: "",
    meta: index1zfBnW0cRNv2eN29gwDOZs687CfLKFF3hUqzmCTHh98Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/index.vue")
  },
  {
    name: "cobalt-prices-slug",
    path: ":slug()",
    meta: _91slug_93SJ5YyTlImcrhEYlKVSHCPye9ceo9bFaiVea9rSDaXhUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/[slug].vue")
  },
  {
    name: "cobalt-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tooltced3pSYcJYm7TG_45053B0Rd3de1hsJbyT4bXCsigDaQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "copper-portal",
    path: "/copper/portal",
    component: () => import("/opt/buildhome/repo/pages/copper/portal.vue")
  },
  {
    name: "lithium",
    path: "/lithium",
    component: () => import("/opt/buildhome/repo/pages/lithium/index.vue")
  },
  {
    name: "nickel-slug",
    path: "/nickel/:slug()",
    meta: _91slug_93ioCyLgO797rT4VKTQgM_YXDlBaSdSP7fSBqEOIPXLxIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/[slug].vue")
  },
  {
    name: pricesGLmo5Hyj3LNYlaN4s8_45JlstKyn3k29jrlBcYww8ntVcMeta?.name,
    path: "/nickel/prices",
    component: () => import("/opt/buildhome/repo/pages/nickel/prices.vue"),
    children: [
  {
    name: "nickel-prices-chart",
    path: "chart",
    meta: chart2HN2eqxHhuHGKdqUtY7zzNFP3lIT_9JAvisFTbkvnp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/chart.vue")
  },
  {
    name: "nickel-prices",
    path: "",
    meta: indexyl_45OzeNbqkwSta3hmXexzhQfmWKBjAQ_ymbIP1CuxzwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/index.vue")
  },
  {
    name: "nickel-prices-slug",
    path: ":slug()",
    meta: _91slug_93fk0slPu7RgEO8MO1aawZkiUeCtGOU8li47DkB8qUKgUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/[slug].vue")
  },
  {
    name: "nickel-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tool2CPFVSdlSq5gxrCi41fTk8IZrLTX5xVayu8KvFumXt0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: pricesfuwmmz7gcD24VAxvHEUL_45wZuOtwCkWu3ZygmjyvQGHwMeta?.name,
    path: "/cathode/prices",
    component: () => import("/opt/buildhome/repo/pages/cathode/prices.vue"),
    children: [
  {
    name: "cathode-prices-chart",
    path: "chart",
    meta: chartg8b0cCAjfokZMR0k7H5g41bJ3mPHMfG3xqHj1I312BsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/chart.vue")
  },
  {
    name: "cathode-prices",
    path: "",
    meta: indexnvKBJb1g0UuHHc1HMLtXSpMGhp2uHP85xJo5KtEAAVYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/index.vue")
  },
  {
    name: "cathode-prices-slug",
    path: ":slug()",
    meta: _91slug_93gFnDl6WQqejdL_IDw3NOYyQGINkXV2IYYUzNpo4uJE4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/prices/[slug].vue")
  }
]
  },
  {
    name: "lithium-slug",
    path: "/lithium/:slug()",
    meta: _91slug_93QiR_45IFfz5gnb_PURgiRlEBQJJbD9_45p7E65H1M_45cokikMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/[slug].vue")
  },
  {
    name: "lithium-prices-nested",
    path: "/lithium/prices",
    meta: pricesr04WsZVosMYNPTGibZ9vrj0RPEfb74rVl8gFiKVWz9MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices.vue"),
    children: [
  {
    name: "lithium-prices-chart",
    path: "chart",
    meta: charteL_ZgnPhxhgSBK4GsjTlFu_ehPBPpDJwg1K8_454R41sEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/chart.vue")
  },
  {
    name: "lithium-prices-index",
    path: "",
    meta: index5RgLDA_w9cQRH1inImhoGpSVl2CsHinA3oF4agwFdMsMeta || {},
    alias: ["table"],
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/index.vue")
  },
  {
    name: "lithium-prices-slug",
    path: ":slug()",
    meta: _91slug_9376Ef1pqhSPK3MZz2fN_45203gkNSSiose3PP63yAmbnoEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/[slug].vue")
  },
  {
    name: "lithium-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45tooliq2dWHKcC7_XbP6xYy00RJIlmy31IOKaZd7PpdUisUEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "tools-api-docs",
    path: "/tools/api/docs",
    meta: docsVT5BrI3IT_Tlfu9ApK34LNO5H75or93GRyO6kNw_GVYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/tools/api/docs.vue")
  },
  {
    name: "fluorspar",
    path: "/fluorspar",
    component: () => import("/opt/buildhome/repo/pages/fluorspar/index.vue")
  },
  {
    name: "manganese",
    path: "/manganese",
    component: () => import("/opt/buildhome/repo/pages/manganese/index.vue")
  },
  {
    name: "phosphate",
    path: "/phosphate",
    component: () => import("/opt/buildhome/repo/pages/phosphate/index.vue")
  },
  {
    name: "recycling",
    path: "/recycling",
    meta: { ...(indexiHP_459aTnVcuNachfyBCN79XBQffLB7okl91Zmpui_45EkMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/recycling/index.vue")
  },
  {
    name: "tools-api",
    path: "/tools/api",
    meta: indexWRMlA4Ul3aF35L_45YOzeuGQIyEoULuQDdW8oeZptPrzMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/tools/api/index.vue")
  },
  {
    name: "recycling-slug",
    path: "/recycling/:slug()",
    meta: _91slug_93vMVVn_2AU_LYP65s8waJQX5QVA8LPJAkVtjeJEIdXYMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/[slug].vue")
  },
  {
    name: "recycling-portal",
    path: "/recycling/portal",
    component: () => import("/opt/buildhome/repo/pages/recycling/portal.vue")
  },
  {
    name: "rare-earths",
    path: "/rare-earths",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/index.vue")
  },
  {
    name: "account-api-access",
    path: "/account/api-access",
    meta: { ...(api_45accessPwZoObqN_o4XW0cPBPJfLl3QkAXdTVdAB4daz7PSOfUMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/api-access.vue")
  },
  {
    name: "anode-data-reports",
    path: "/anode/data-reports",
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports.vue"),
    children: [
  {
    name: "anode-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts3IvqGGprpUYGk5jhOVbHxacCEOarLvy77lvyeYrpZO4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports/forecasts.vue")
  },
  {
    name: "anode-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsPWvhULnhXknsD4_45gy15GT4vXVs2V6i6NiotM3It0JGUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "rare-earths-slug",
    path: "/rare-earths/:slug()",
    meta: _91slug_93nLwwDfZ_FuTf7ShngM6xEfFsHlixpW07o_k_45qAarL2IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/[slug].vue")
  },
  {
    name: pricesVhUiI68Gm9juvXqkg8W919ZjqghBWqxKglQ8B2FAU6oMeta?.name,
    path: "/rare-earths/prices",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices.vue"),
    children: [
  {
    name: "rare-earths-prices-chart",
    path: "chart",
    meta: charttexBeRB82x0IvBMp1IzjNFVcyXJWtjwtJohWEHNyyVIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/chart.vue")
  },
  {
    name: "rare-earths-prices",
    path: "",
    meta: indexT4WR7U87NgilL3KdNawsWbjnA4yosLts5oSjEK2ON3IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/index.vue")
  },
  {
    name: "rare-earths-prices-slug",
    path: ":slug()",
    meta: _91slug_93ZXw6TB6Fu9btkVLSm4zMahCcv_3wP2SDvoYoSetLlqUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/prices/[slug].vue")
  }
]
  },
  {
    name: "cobalt-data-reports",
    path: "/cobalt/data-reports",
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports.vue"),
    children: [
  {
    name: "cobalt-data-reports-forecasts",
    path: "forecasts",
    meta: forecastswWTMCeEeZMqD7_45ROr4fhdkb2hpM8LYCpqhPhrQ6efAwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports/forecasts.vue")
  },
  {
    name: "cobalt-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsMafhNoNLzAIaTTdXEpBpSpk38u_45NP39Z9R8TMUL_45W6sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "copper-data-reports",
    path: "/copper/data-reports",
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports.vue"),
    children: [
  {
    name: "copper-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsY2ZE2pWQVzJGhKhpCvNTuUnAxynX9paY6STXUCZKXH8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports/forecasts.vue")
  },
  {
    name: "copper-data-reports-copper-briefing",
    path: "copper-briefing",
    meta: copper_45briefingo_BfcMqB92NCOddwCLy0UzA4WXHyApkNb0DUhdZbTSEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/data-reports/copper-briefing.vue")
  }
]
  },
  {
    name: "nickel-data-reports",
    path: "/nickel/data-reports",
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports.vue"),
    children: [
  {
    name: "nickel-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsZHqrEclrJvzMk9Pp8EB4mZIAUWmJFgkY_4553JzhajdHoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports/forecasts.vue")
  },
  {
    name: "nickel-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsl2WZJLg1kRluP_LgLDdeppiF7cuYQGYEEAeAU76UKvYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "silicon-anode",
    path: "/silicon-anode",
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/index.vue")
  },
  {
    name: "excel-add-in",
    path: "/excel-add-in",
    meta: excel_45add_45inkLpB7V30LFWT33tZ2u_45merba1hB0B1OIQz5yJ_aHQf0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/(tools)/excel-add-in.vue")
  },
  {
    name: "cathode-data-reports",
    path: "/cathode/data-reports",
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports.vue"),
    children: [
  {
    name: "cathode-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsy7ILvQmepxTh90vSjydKOfDz12wakD5W24y54oSkI7oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/forecasts.vue")
  },
  {
    name: "cathode-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentszPSDrMkqlF6_45PDwG6_CA1A0GCeTJiEB1fzPyAu_45M4BUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/price-assessments.vue")
  },
  {
    name: "cathode-data-reports-market-assessments",
    path: "market-assessments",
    meta: market_45assessmentsNBA70qiYi6i8b8xgJq7ija5smxnaEpflZAwTGrIjPRUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/data-reports/market-assessments.vue")
  }
]
  },
  {
    name: "lithium-data-reports",
    path: "/lithium/data-reports",
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports.vue"),
    children: [
  {
    name: "lithium-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts81PBPUNkXuwxgNjH6STLKAH4VxrROISq69bG5a994VgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/forecasts.vue")
  },
  {
    name: "lithium-data-reports-sustainability",
    path: "sustainability",
    meta: sustainability_45Cvpto0q1X29YdY8LdDbL1f4tL5C3xTcpmKUaQA83JgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/sustainability.vue")
  },
  {
    name: "lithium-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsoQ_tH3hE3ijN35zbk_45BsN1EBajFvDlcZE2adkwPYF4IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "new-technology",
    path: "/new-technology",
    meta: { ...(indexUVUbiAmmZwjFLCnBTStGBUj8_45nU2H71POr7C2uvRudkMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/new-technology/index.vue")
  },
  {
    name: "account-subscriptions",
    path: "/account/subscriptions",
    meta: { ...(subscriptionsef8m95Q1E_45J79LcAd_45RAY3qfixo1CSpfsxjqNkfKKfoMeta || {}), ...{"middleware":["authenticated"]} },
    component: () => import("/opt/buildhome/repo/pages/account/subscriptions.vue")
  },
  {
    name: "anode-market-insights",
    path: "/anode/market-insights",
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights.vue"),
    children: [
  {
    name: "anode-market-insights-videos",
    path: "videos",
    meta: videosy5MiVRdy2L0bmp2J41MlNQYSqsC55587_MPpizBiApIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/videos.vue")
  },
  {
    name: "anode-market-insights-analysis",
    path: "analysis",
    meta: analysis5FFClH0s3_Z9DfXtMj8JRr31rrY7vEU9mjOB__451cFxYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/analysis.vue")
  },
  {
    name: "anode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights_45JCgfsA4mqrMoEqIBpCOy8kJMR4hjCEFtfuOpNklEU4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "cobalt-sustainability",
    path: "/cobalt/sustainability",
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability.vue"),
    children: [
  {
    name: "cobalt-sustainability-lca",
    path: "lca",
    meta: lcayx_45ZHm5ATA3otzyD52GFUv_45YZrmQ_45PQTHcfQnZ9ibzYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/lca.vue")
  },
  {
    name: "cobalt-sustainability-overview",
    path: "overview",
    meta: { ...(overviewOiSHrrphhatmJCe2BWFVh1eCsjJUdfuG1J4L9LPEEEcMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/overview.vue")
  },
  {
    name: "cobalt-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexPxo5pxfv8uRaz2YnuUWwtFYrOWSXhrQLbd4KQNp__45hMMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/cobalt/sustainability/sustainability-index.vue")
  }
]
  },
  {
    name: "new-technology-portal",
    path: "/new-technology/portal",
    component: () => import("/opt/buildhome/repo/pages/new-technology/portal.vue")
  },
  {
    name: "nickel-sustainability",
    path: "/nickel/sustainability",
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability.vue"),
    children: [
  {
    name: "nickel-sustainability-lca",
    path: "lca",
    meta: lcaZaBFLidf51Nik5KU1lm_453FA7IkhtqtdO4W0IHi68eD0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/lca.vue")
  },
  {
    name: "nickel-sustainability-overview",
    path: "overview",
    meta: { ...(overviewpDONLyavM7wWQwmoi5fqHk34cz83iURPUSqdsrJbz2cMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/overview.vue")
  },
  {
    name: "nickel-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexWE8xj0imX3ZZJIUpQw9UjmmjU6SCaaj1ouM_wrizCHUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/nickel/sustainability/sustainability-index.vue")
  }
]
  },
  {
    name: "cobalt-market-insights",
    path: "/cobalt/market-insights",
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights.vue"),
    children: [
  {
    name: "cobalt-market-insights-videos",
    path: "videos",
    meta: videosfjbFi30_45rY_jXx60zayApKwRibQjf53Rw1saKzWSQSEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/videos.vue")
  },
  {
    name: "cobalt-market-insights-analysis",
    path: "analysis",
    meta: analysisu1fmvvcBMbhS6vTsxbg8lghUNehgRZvqWQsKeeko6ggMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/analysis.vue")
  },
  {
    name: "cobalt-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightscjYrhSCoDX07vbvyFXAWp0FdMpxSjiQbUCdqKHemmtIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cobalt/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "copper-market-insights",
    path: "/copper/market-insights",
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights.vue"),
    children: [
  {
    name: "copper-market-insights-videos",
    path: "videos",
    meta: videosnrJQHrkuQe7hWYr9yVKTOR0RUrMZ9ivKalf9UrgTUQoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/videos.vue")
  },
  {
    name: "copper-market-insights-analysis",
    path: "analysis",
    meta: analysis5_SOI7W6_6pDje3YGNhXZegE7x8AmH3rqGgNta40wlYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/analysis.vue")
  },
  {
    name: "copper-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsDVMy160VIkGeQGSlyRG1_vzpwiF3Kw1E2fFXW55ILxkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/copper/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "fluorspar-data-reports",
    path: "/fluorspar/data-reports",
    component: () => import("/opt/buildhome/repo/pages/fluorspar/data-reports.vue"),
    children: [
  {
    name: "fluorspar-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsa9WT5jxj6deKOkW6Ezb_Fmy3CLfTRgcddOaSyw1KGB8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "lithium-sustainability",
    path: "/lithium/sustainability",
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability.vue"),
    children: [
  {
    name: "lithium-sustainability-lca",
    path: "lca",
    meta: lcaf7X6UACeaKEWCjUXVHYczDwgw_451G1iES2RS_L8AlTVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/lca.vue")
  },
  {
    name: "lithium-sustainability-overview",
    path: "overview",
    meta: { ...(overview8T1RWuRf6net1QW8iUWX0WnZ7iioLX_JNeLJJBx3rw0Meta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/overview.vue")
  },
  {
    name: "lithium-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexheyROYfwaI3xtQFWRDpPpheqpIkTAik_njvWEAqucM4Meta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/sustainability-index.vue")
  },
  {
    name: "lithium-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserxkEwC5fkTnREyQ_QvfOtD3UPc04aVK30Eoit5eL_45268Meta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "manganese-data-reports",
    path: "/manganese/data-reports",
    component: () => import("/opt/buildhome/repo/pages/manganese/data-reports.vue"),
    children: [
  {
    name: "manganese-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsqhz6DZ_5ahlGd42Xj5a0DyDJJi9gd6wRdXGGydNHTDwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "natural-graphite",
    path: "/natural-graphite",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/index.vue")
  },
  {
    name: "nickel-market-insights",
    path: "/nickel/market-insights",
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights.vue"),
    children: [
  {
    name: "nickel-market-insights-videos",
    path: "videos",
    meta: videosct7YXBA8E9UNyUyx0giUwiUwnnmNEhFBFmxvm88K1r0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/videos.vue")
  },
  {
    name: "nickel-market-insights-analysis",
    path: "analysis",
    meta: analysisV8x2wsWnfOSi9VUF_UUkqogCWlPrUwagyiDeFJ_45Xe0AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/analysis.vue")
  },
  {
    name: "nickel-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsyqJb75QXjoaS718x_45Tp_lDTrNhai_45P2bXbeAO_45MoIEIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/nickel/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "phosphate-data-reports",
    path: "/phosphate/data-reports",
    component: () => import("/opt/buildhome/repo/pages/phosphate/data-reports.vue"),
    children: [
  {
    name: "phosphate-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsWJXcSRnSJh6FSPydQa6fFBKhs5h_45s72Z4sVqBrnVoPsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "recycling-data-reports",
    path: "/recycling/data-reports",
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports.vue"),
    children: [
  {
    name: "recycling-data-reports-forecasts",
    path: "forecasts",
    meta: forecastseYADkzkcfdqJo1n_45Crnq_45UbTp9YNpvwa6_X_45YGBsmlwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports/forecasts.vue")
  },
  {
    name: "recycling-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessments0dk6nCKYyPX1PHUqi0iWeP9voI8rYzlxkIS7NhO4xUEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: capacity_45databasee7l3ptyb4PBHK49UF0_45vwBoZZBEicrXXeJVw5tkExhkMeta?.name,
    path: "/anode/capacity-database",
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database.vue"),
    children: [
  {
    name: "anode-capacity-database",
    path: "",
    meta: index59bt1rmJZPF5B1AXzbCYXGUlccWvaORTCmQyf8uvAR4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database/index.vue")
  },
  {
    name: "anode-capacity-database-sodium-ion-anode",
    path: "sodium-ion-anode",
    meta: sodium_45ion_45anode6HYcK_455cnUsCcufm5p9YCRAO6kUog4fizC__4GxCdRcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/anode/capacity-database/sodium-ion-anode.vue")
  }
]
  },
  {
    name: "cathode-market-insights",
    path: "/cathode/market-insights",
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights.vue"),
    children: [
  {
    name: "cathode-market-insights-videos",
    path: "videos",
    meta: videosVoLh_OnGnlWqnnBqN8JN9lfZZ_45Ea5I1XftJUqPWNuM0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/videos.vue")
  },
  {
    name: "cathode-market-insights-analysis",
    path: "analysis",
    meta: analysis79bxjcLYh5cEitnEPVYtiQ04193bkSlt9Gi6A6gsnqoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/analysis.vue")
  },
  {
    name: "cathode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsjeY_p42kgvoKDh1Tk5P9ii1RJ1ImiHUF3gX29kwDkg4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "lithium-market-insights",
    path: "/lithium/market-insights",
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights.vue"),
    children: [
  {
    name: "lithium-market-insights-videos",
    path: "videos",
    meta: videosF8JU2lzZwewvlRH4KBsuhk7dlXWcNbgArzcdVrpWwjIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/videos.vue")
  },
  {
    name: "lithium-market-insights-analysis",
    path: "analysis",
    meta: analysis1a_FKHv0M2pcWOhwC5lzbYZBY0eHP2qRpN814d84iBQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/analysis.vue")
  },
  {
    name: "lithium-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsIW0hwN71Mi1H06SnPg8GOL6Cld7e_eLTRieBqe99Ao8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/lithium/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "natural-graphite-slug",
    path: "/natural-graphite/:slug()",
    meta: _91slug_93hFDYNoOn5JPJkLetDsmmV6hESng88HNmx58klRfVDc4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/[slug].vue")
  },
  {
    name: pricesPqFK_45fp_5oTSpxAe8qj6c98yKd4HTrJ524ET1K5N6P4Meta?.name,
    path: "/natural-graphite/prices",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices.vue"),
    children: [
  {
    name: "natural-graphite-prices-chart",
    path: "chart",
    meta: charttcUJKh0e_45IU6ZIrIhnGeIADKU8HYidR06on1tbbpLVAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/chart.vue")
  },
  {
    name: "natural-graphite-prices",
    path: "",
    meta: indexyiHprQZOFqpNOOiyJeC3w2NXSv745ik1WVFMuHBu0CkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/index.vue")
  },
  {
    name: "natural-graphite-prices-slug",
    path: ":slug()",
    meta: _91slug_93I_U2Nt3gflNitMu9eI9Kql7pF5bKHQX42TevxWRWMUYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/[slug].vue")
  },
  {
    name: "natural-graphite-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45toolKj1TXNon5EeyEnhM_45bQRH5TtD_2W9n6cwbF1EZQkOPEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "rare-earths-data-reports",
    path: "/rare-earths/data-reports",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports.vue"),
    children: [
  {
    name: "rare-earths-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts2F3r_45x7PZfr4UlpYbQvHJ33qnzThmxsW7CPDlBl5TyUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/forecasts.vue")
  },
  {
    name: "rare-earths-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityDxjSzjD10HbEV9EidxDExoIe4wZrbT1WlLSNMNxpECoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/sustainability.vue")
  },
  {
    name: "rare-earths-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsC3_45XGH3WzlJR_45ilbNxGyC5Qd0t3fd2scvM0JQF9XOv0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "synthetic-graphite",
    path: "/synthetic-graphite",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/index.vue")
  },
  {
    name: "battery-gigafactory",
    path: "/battery-gigafactory",
    meta: { ...(indexg_VlOVtVubGPiI0xh_hA_45TvAQYh9BKrLhlPit18edXEMeta || {}), ...{"middleware":["premium-market-guard"]} },
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/index.vue")
  },
  {
    name: capacity_45databaseFSnHeDo1aAHeEh_459j1JnM7LaMVkISGj8wffjzQlAVdgMeta?.name,
    path: "/cathode/capacity-database",
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database.vue"),
    children: [
  {
    name: "cathode-capacity-database",
    path: "",
    meta: indexlZMtPlsjQO4dc9q6Ym_CuZsWREDDaO_45bKCvfOUNNzxwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/index.vue")
  },
  {
    name: "cathode-capacity-database-precursor",
    path: "precursor",
    meta: precursorQcp_x83GfokouyURfYws_fnQLNKRZK_go9DovuMLkd4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/precursor.vue")
  },
  {
    name: "cathode-capacity-database-sodium-ion-cathode",
    path: "sodium-ion-cathode",
    meta: sodium_45ion_45cathode8f_gXVdMQWt_45_45ekL_vWQO_nZzs5g_45jFBWgrEnjNLfr0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/cathode/capacity-database/sodium-ion-cathode.vue")
  }
]
  },
  {
    name: "fluorspar-market-insights",
    path: "/fluorspar/market-insights",
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights.vue"),
    children: [
  {
    name: "fluorspar-market-insights-videos",
    path: "videos",
    meta: videoskqyxF7jy9PnZ1jDEqmteQk3hIMh4jMejeUz6SqvZjo0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/videos.vue")
  },
  {
    name: "fluorspar-market-insights-analysis",
    path: "analysis",
    meta: analysisbUlncyfMIlJpLAVvUUVvqehd005v0PgAq38_45HxwNeSIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/analysis.vue")
  },
  {
    name: "fluorspar-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsy_oQxWsmyAiuOBAoyw4g1KEpIs_PJJ7qjOc5jVMnGjYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fluorspar/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "manganese-market-insights",
    path: "/manganese/market-insights",
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights.vue"),
    children: [
  {
    name: "manganese-market-insights-videos",
    path: "videos",
    meta: videos1PrpHdQzU6pnJ9mmu7kUDOl840655uEAh_45_PY_45v8BUUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/videos.vue")
  },
  {
    name: "manganese-market-insights-analysis",
    path: "analysis",
    meta: analysis1KicjvkWw8JC3GGsw_Dhqj9UPe29In9FmNQ0qweCFe0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/analysis.vue")
  },
  {
    name: "manganese-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightss3V52jfdh0dDsdyinmOo5sAk_45gJHHs2r7xSRriYMyg0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/manganese/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "phosphate-market-insights",
    path: "/phosphate/market-insights",
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights.vue"),
    children: [
  {
    name: "phosphate-market-insights-videos",
    path: "videos",
    meta: videos1qVEKZGjHk_AJmawVd0oeFfZ1KFRSzeCSyi3Rjm_45xXsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/videos.vue")
  },
  {
    name: "phosphate-market-insights-analysis",
    path: "analysis",
    meta: analysisnog_45e13M66QjzZZCWS8uYSXbBabyg5KY7GIX1WEzGDEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/analysis.vue")
  },
  {
    name: "phosphate-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightszCDr_45UCacJc6Mzb_45Rb1x5nqYvzy0r9YoQPWUe3051isMeta || {},
    component: () => import("/opt/buildhome/repo/pages/phosphate/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "recycling-market-insights",
    path: "/recycling/market-insights",
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights.vue"),
    children: [
  {
    name: "recycling-market-insights-videos",
    path: "videos",
    meta: videosUD9lI68mx_45lPTnTtGeXk_45WBE2jMChlHLIc7ZcTuFTYUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/videos.vue")
  },
  {
    name: "recycling-market-insights-analysis",
    path: "analysis",
    meta: analysisske8hu_45i9MzfTcJIBOq_45Hi3ZLr4ClN0ASh7DC_45EBZTIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/analysis.vue")
  },
  {
    name: "recycling-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights9EQQ4qc2i3C992dsbiDbTcke7KTB3rQKOlfqQblW17wMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "synthetic-graphite-slug",
    path: "/synthetic-graphite/:slug()",
    meta: _91slug_93XVV7pHxh0P2Ub_UWh9eTsKfCB_NIBXrjtwKuupSfVMwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/[slug].vue")
  },
  {
    name: priceslFCozIzKvzh7HqTQE0hsdOYkBWnrHAvbTg7IecnOoEcMeta?.name,
    path: "/synthetic-graphite/prices",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices.vue"),
    children: [
  {
    name: "synthetic-graphite-prices-chart",
    path: "chart",
    meta: chartphzVXtDbi_5ZcR_45CGbmUkFqLJ2D2zODv1xZV3StLKj8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/chart.vue")
  },
  {
    name: "synthetic-graphite-prices",
    path: "",
    meta: index_45JXSe5i9wiyNW_45v7xMDNN2FRY0nOzlAYvEq8gsneMSMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/index.vue")
  },
  {
    name: "synthetic-graphite-prices-slug",
    path: ":slug()",
    meta: _91slug_93fTlU5OeCdw6Aj4Bph5fuN2_45UwfqP1CAmrbvTJpuQqEoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/[slug].vue")
  },
  {
    name: "synthetic-graphite-prices-price-customisation-tool",
    path: "price-customisation-tool",
    meta: price_45customisation_45toolbidZOjWILLSf9O9xAW9fB0sEBH2IFSR_9N8INSUz1ckMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/prices/price-customisation-tool.vue")
  }
]
  },
  {
    name: "battery-gigafactory-portal",
    path: "/battery-gigafactory/portal",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/portal.vue")
  },
  {
    name: "rare-earths-sustainability",
    path: "/rare-earths/sustainability",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability.vue"),
    children: [
  {
    name: "rare-earths-sustainability-lca",
    path: "lca",
    meta: lcaxoFOsuSwKQb8tvTv3nSTqveEln_o_45XRGORB53eTbWPAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/lca.vue")
  },
  {
    name: "rare-earths-sustainability-overview",
    path: "overview",
    meta: { ...(overviewseruQu25iPLw__ti_WGPGSEtaDBI3DtESohmBWG3OuwMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/overview.vue")
  },
  {
    name: "rare-earths-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indextXXGfoXEGn3iYjzp2POvI_3yJX0KMxp2lZtYB_45e9_BUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/rare-earths/sustainability/sustainability-index.vue")
  }
]
  },
  {
    name: "silicon-anode-data-reports",
    path: "/silicon-anode/data-reports",
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/data-reports.vue"),
    children: [
  {
    name: "silicon-anode-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsM2Exh7WIHeUe14hSTbD7WxwYx3RBA7DCMq6RYdzdUkcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "new-technology-data-reports",
    path: "/new-technology/data-reports",
    component: () => import("/opt/buildhome/repo/pages/new-technology/data-reports.vue"),
    children: [
  {
    name: "new-technology-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsDaiL_2OV881qCf22HIymn_45wT9AmeHaWlXC4MmJv2d_cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/data-reports/forecasts.vue")
  }
]
  },
  {
    name: "rare-earths-market-insights",
    path: "/rare-earths/market-insights",
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights.vue"),
    children: [
  {
    name: "rare-earths-market-insights-videos",
    path: "videos",
    meta: videos9C950AHA8vq8KkjSEgBZ63RLSMcSv0wjIpdfkKlxnecMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/videos.vue")
  },
  {
    name: "rare-earths-market-insights-analysis",
    path: "analysis",
    meta: analysisRkzKQgzK_iTGniALJOXkL2NH2juv_arQ80gUEjzj9tAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/analysis.vue")
  },
  {
    name: "rare-earths-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsIeRbaUqxZBWpLP09IveEoA6OINVYFInWRb2wgJukTzsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-earths/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: black_45mass_45prices4pzz_REFyAbbL_3kOWyJaY6t6IEYzCJ2Wkk_45OcgH3BoMeta?.name,
    path: "/recycling/black-mass-prices",
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices.vue"),
    children: [
  {
    name: "recycling-black-mass-prices-chart",
    path: "chart",
    meta: chartaTXhIT6_hAQmVmAUEuTvACXgXm2hY3FyC5nVvvQSLcUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/chart.vue")
  },
  {
    name: "recycling-black-mass-prices",
    path: "",
    meta: index6PNkphKUs0xAC5idz0vkTJDVQZp_pQ27na3iBzH244AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/index.vue")
  },
  {
    name: "recycling-black-mass-prices-slug",
    path: ":slug()",
    meta: _91slug_93PO3QpZcwMEyVk62yvFFzeWLC_YGd_F1w3sngwH1CM7sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/recycling/black-mass-prices/[slug].vue")
  }
]
  },
  {
    name: "natural-graphite-data-reports",
    path: "/natural-graphite/data-reports",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports.vue"),
    children: [
  {
    name: "natural-graphite-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts_SPAejp_sbgY1blBL15_4533YM98RYIUUUk_45ZUAHicatgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/forecasts.vue")
  },
  {
    name: "natural-graphite-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityuvcVYKUbN7UY4ehckJs4tMq_t_idpFnI7cHQ_4579X2_450Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/sustainability.vue")
  },
  {
    name: "natural-graphite-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentshBFZqzulBQxxANaNYDbac5SZtlaJEkZ4Gomh9q4Dh9oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "price-dashboard-chart-builder",
    path: "/price-dashboard/chart-builder",
    meta: chart_45builderlr6t8ngqoqfqxbU9_45N_JoNIGuRJEtxe2Rkb7ZGTJH70Meta || {},
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/chart-builder.vue")
  },
  {
    name: "silicon-anode-market-insights",
    path: "/silicon-anode/market-insights",
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights.vue"),
    children: [
  {
    name: "silicon-anode-market-insights-videos",
    path: "videos",
    meta: videosTdoIRuhAzEEndBQvQWKD6V3KB0iuu_4y1dWO4HpZUFoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/videos.vue")
  },
  {
    name: "silicon-anode-market-insights-analysis",
    path: "analysis",
    meta: analysisZmBLceel3q13JNUtuvWS23Kukt9L54_45csgtyxWqNvcYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/analysis.vue")
  },
  {
    name: "silicon-anode-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsyMzDn1yaPcKFGI_WteHLz_45O9rhf25nMAl3d3DTxsbQ4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/silicon-anode/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "new-technology-market-insights",
    path: "/new-technology/market-insights",
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights.vue"),
    children: [
  {
    name: "new-technology-market-insights-videos",
    path: "videos",
    meta: videoscK9da_9Rv1JIraHrzZA8ghJvJGTMq31OCg_Dae7FUB4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/videos.vue")
  },
  {
    name: "new-technology-market-insights-analysis",
    path: "analysis",
    meta: analysis8_my2XChk3PRA2DFDPU25MVWnlyfHcfS26py0ZFGvNkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/analysis.vue")
  },
  {
    name: "new-technology-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsiViy2OdOhzByJJAKXJTFIkn4__SN_453OZZJR11vJRkXsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/new-technology/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "price-dashboard-watchlist-id",
    path: "/price-dashboard/watchlist/:id()",
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/watchlist/[id].vue")
  },
  {
    name: "natural-graphite-sustainability",
    path: "/natural-graphite/sustainability",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability.vue"),
    children: [
  {
    name: "natural-graphite-sustainability-lca",
    path: "lca",
    meta: lca50Mu2Us9_tmSXZljHPCgg_45BjA9WEbwvncEJCiGR4lVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/lca.vue")
  },
  {
    name: "natural-graphite-sustainability-overview",
    path: "overview",
    meta: { ...(overviewcC3cqKqf8KKcWNYve6_45HkSlffqxhMm_45BczOEaJ_45IdBcMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/overview.vue")
  },
  {
    name: "natural-graphite-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexneUZ52JNw0BJFtrEL_45_09xeBBVporaptGY2Nw3sXtOUMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/sustainability-index.vue")
  },
  {
    name: "natural-graphite-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserCeC_R_604avO_ZNKVCEFYFAZEkJ95uF3TRloiMbGkEoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "price-dashboard-watchlist",
    path: "/price-dashboard/watchlist",
    component: () => import("/opt/buildhome/repo/pages/price-dashboard/watchlist/index.vue")
  },
  {
    name: "synthetic-graphite-data-reports",
    path: "/synthetic-graphite/data-reports",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports.vue"),
    children: [
  {
    name: "synthetic-graphite-data-reports-forecasts",
    path: "forecasts",
    meta: forecastsQm8J_45GWfyJ7deQCfAUrCYzf5LMse25QvHneyLoDvwoMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/forecasts.vue")
  },
  {
    name: "synthetic-graphite-data-reports-sustainability",
    path: "sustainability",
    meta: sustainabilityo1ipOGWYHkIxbq13M1YqwqjAYRSWQ7GMGu9ONtxN71oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/sustainability.vue")
  },
  {
    name: "synthetic-graphite-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsVOv21o3fPLQb4GrRovYMBKr49WQs6JJ5VxAv0uLnTCAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/data-reports/price-assessments.vue")
  }
]
  },
  {
    name: "battery-gigafactory-data-reports",
    path: "/battery-gigafactory/data-reports",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports.vue"),
    children: [
  {
    name: "battery-gigafactory-data-reports-forecasts",
    path: "forecasts",
    meta: forecasts69Zg4JpnM7U13Ja3EF2xvczl8ybgDxzmqF_45xj2ZBT1sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/forecasts.vue")
  },
  {
    name: "battery-gigafactory-data-reports-price-assessments",
    path: "price-assessments",
    meta: price_45assessmentsc4DuL6Qtq9BG9DQCvAtedEoo_45IsZeClGR9o4XPV1acIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/price-assessments.vue")
  },
  {
    name: "battery-gigafactory-data-reports-market-assessments",
    path: "market-assessments",
    meta: market_45assessmentsTptWk9rthyQqHXf7fNV6u8m_45I14vkrvEM4syvhqVLJ8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/data-reports/market-assessments.vue")
  }
]
  },
  {
    name: "natural-graphite-market-insights",
    path: "/natural-graphite/market-insights",
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights.vue"),
    children: [
  {
    name: "natural-graphite-market-insights-videos",
    path: "videos",
    meta: videos8QQy85x165BbCeXcjr_4FYnS0DMZjbWeVzMSFuChhvYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/videos.vue")
  },
  {
    name: "natural-graphite-market-insights-analysis",
    path: "analysis",
    meta: analysisD_2hag6U4b16g_4J6zS2fOioEWxDIRmABco91ldFCA8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/analysis.vue")
  },
  {
    name: "natural-graphite-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insights3pn3HKWcEYwzKeGauhpfFZqls6Tz7Wh3p7l8ZImrhXQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/natural-graphite/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "synthetic-graphite-sustainability",
    path: "/synthetic-graphite/sustainability",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability.vue"),
    children: [
  {
    name: "synthetic-graphite-sustainability-lca",
    path: "lca",
    meta: lcaWQ_XjzbRRtMQwsQF0LHMeae9bZ3v_45fALPuLApiQCwDMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/lca.vue")
  },
  {
    name: "synthetic-graphite-sustainability-overview",
    path: "overview",
    meta: { ...(overview97z0CWhh8uCHPkjuvl2_ybGPIyikIOwXw6CIwzlrJSMMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/overview.vue")
  },
  {
    name: "synthetic-graphite-sustainability-sustainability-index",
    path: "sustainability-index",
    meta: { ...(sustainability_45indexe7ePvFcIuRqxtG_TffLK5P3H8_456uFjk3iDHIvOFly6QMeta || {}), ...{"middleware":"redirect-tab"} },
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/sustainability-index.vue")
  },
  {
    name: "synthetic-graphite-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "battery-emissions-analyser",
    path: "/battery-emissions-analyser",
    meta: battery_45emissions_45analyserJZm_45OEOnUwb3_c_1X098pltBhAPAGyyT1h7UY2dM2TUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/(tools)/battery-emissions-analyser.vue")
  },
  {
    name: "battery-gigafactory-sustainability",
    path: "/battery-gigafactory/sustainability",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability.vue"),
    children: [
  {
    name: "battery-gigafactory-sustainability-overview",
    path: "overview",
    meta: overviewPorE21G2DcJvXbC2zB9xGLjikG45aEENrm_5mGcJqQQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability/overview.vue")
  },
  {
    name: "battery-gigafactory-sustainability-battery-emissions-analyser",
    path: "battery-emissions-analyser",
    meta: battery_45emissions_45analyserCbZyhGlfVk43_45UYSJRmFk0IGrb2iEvlhlQLRmNEEuRMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/sustainability/battery-emissions-analyser.vue")
  }
]
  },
  {
    name: "synthetic-graphite-market-insights",
    path: "/synthetic-graphite/market-insights",
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights.vue"),
    children: [
  {
    name: "synthetic-graphite-market-insights-videos",
    path: "videos",
    meta: videosFgYARxTX82gCmew1FsOwNF_PD5tMFd_45W3SOESwCgKmQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/videos.vue")
  },
  {
    name: "synthetic-graphite-market-insights-analysis",
    path: "analysis",
    meta: analysisJyYEHqLSh7FoHIGE00oRhBazBnfdW2tZto1tIkA2OWkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/analysis.vue")
  },
  {
    name: "synthetic-graphite-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightstENqEa19jEQuKHTejOqETWAHiowVRpPu71T6Np63y_45MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/synthetic-graphite/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: "battery-gigafactory-market-insights",
    path: "/battery-gigafactory/market-insights",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights.vue"),
    children: [
  {
    name: "battery-gigafactory-market-insights-videos",
    path: "videos",
    meta: videosNp3LGbSz_45Fi6zHbglRQS3bNCUb3YVdPFqGCRfR_45fWW8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/videos.vue")
  },
  {
    name: "battery-gigafactory-market-insights-analysis",
    path: "analysis",
    meta: analysisvnlDS022c5PHjBlNjjxYMqlAJxXJOXbdrrzTaMduP_45IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/analysis.vue")
  },
  {
    name: "battery-gigafactory-market-insights-critical-insights",
    path: "critical-insights",
    meta: critical_45insightsW6vfrvQHX60i_45O_45_45HDRLK9BUT998DerUIDSqTAvCwBMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/market-insights/critical-insights.vue")
  }
]
  },
  {
    name: capacity_45databaseco42LG5QtrGnwlJrYDpDh7uiRmc17mtK4jSLOnCwHKcMeta?.name,
    path: "/battery-gigafactory/capacity-database",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database.vue"),
    children: [
  {
    name: "battery-gigafactory-capacity-database",
    path: "",
    meta: indexBlR3koxPdeiuXWb4O0X_IasfaD6FoYz2u111LdRFRuwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/index.vue")
  },
  {
    name: "battery-gigafactory-capacity-database-battery-cell",
    path: "battery-cell",
    meta: battery_45cellzh_lsHvarVb1FIm6dRcach7u1RCj9gm7i2E_45CUHdUw0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/battery-cell.vue")
  },
  {
    name: "battery-gigafactory-capacity-database-sodium-ion-capacities",
    path: "sodium-ion-capacities",
    meta: sodium_45ion_45capacitiesrTNtQAlnQH2cwCm2t2EI4gJx5DYeCatPtZORHc2ZXhkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/capacity-database/sodium-ion-capacities.vue")
  }
]
  },
  {
    name: "market-market-insights-briefings",
    path: "/:market()/market-insights/briefings",
    component: () => import("/opt/buildhome/repo/pages/[market]/market-insights/briefings/index.vue")
  },
  {
    name: lithium_45ion_45batteries_45pricesc1qoYTLD6ULkoQ9aBDx2jBIgxAocVkssX6d_FvP4VS0Meta?.name,
    path: "/battery-gigafactory/lithium-ion-batteries-prices",
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices.vue"),
    children: [
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices-chart",
    path: "chart",
    meta: chart9Vq24jqjf6ycod09reGJLcmT8DeOZXfOihrIjrdqDx8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/chart.vue")
  },
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices",
    path: "",
    meta: indexXW_73qxVw_45AO29bMNzSXAJK3RU89H68LA6Ix9p64_q0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/index.vue")
  },
  {
    name: "battery-gigafactory-lithium-ion-batteries-prices-slug",
    path: ":slug()",
    meta: _91slug_93M9Fp0dxzKsebaAaHG0un8dU2nR0q35p8o0UmJs4ToLMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/battery-gigafactory/lithium-ion-batteries-prices/[slug].vue")
  }
]
  },
  {
    name: "market-market-insights-briefings-category-slug",
    path: "/:market()/market-insights/briefings/:category()/:slug()",
    component: () => import("/opt/buildhome/repo/pages/[market]/market-insights/briefings/[category]/[slug].vue")
  },
  {
    name: "market-subCategory-video-by-id",
    path: "/:market/data-reports/:subCategory/video/:id",
    meta: { ...(_91id_93aHRD_45C62bpxQlXiJyTO0jL2I7qPg_pOCc0_xNnliX94Meta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/[subCategory]/video/[id].vue")
  },
  {
    name: "market-subCategory-report-by-id",
    path: "/:market/data-reports/:subCategory/report/:id",
    meta: { ...(_91id_93fW65Rf0tLwtKeru2QgILXBNROxdqKSkj74UAHmNka1IMeta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/[subCategory]/report/[id].vue")
  },
  {
    name: "market-report-by-id",
    path: "/:market/data-reports/report/:id",
    meta: { ...(_91id_935fjG9iKCprPRoUGUgPHbl5pkqVS5lZAMFE6hwtlKstQMeta || {}), ...{"middleware":["has-active-membership"]} },
    component: () => import("~/custom-pages/[market]/data-reports/report/[id].vue")
  }
]